/* global AdapterHash */
'use strict';

/**
 * Hash Helper
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdHashHelper for ES6 usage
 *          3.0.0 #249 Refactor wdStorageService versioning
 *
 * @author Dallas Vogels <dvogels@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com> 
 *
 * @copyright (c) 2016-2020 Build Centrix
 */


var wdHashHelper = angular.module('wd.helper.hash', [])
    .factory('wdHashHelper',

        function ()
        {
            var resource;

            resource = new AdapterHash();

            return resource;
        });
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdHashHelper;
}  
// EOF